import IAPIResult from "models/IAPIResult";
import ISalesZone, { ISalesZoneCreateOrUpdate, ISalesZoneFilters, ISalesZoneInitResult } from "models/sql/ISalesZone";
import { fetchGetAsync, fetchPostAsync } from "utilities/Fetch";
import APIService from "./APIService";
import { IFireDepartmentFilters } from "models/sql/IFireDepartment";

const SERVICE_PATH = "SalesZone";

export default class SalesZoneService {
    static async GetAllAsync(accessToken: string, start: number, count: number, filters: ISalesZoneFilters): Promise<{ total: number, records: ISalesZone[] | null, records2: null[] | null }> {
        return await APIService.GetAllAsync<ISalesZone, null>(accessToken, SERVICE_PATH, start, count, filters);
    }

    static async GetAsync(accessToken: string, id: number): Promise<{ record: ISalesZone | null, record2: null }> {
        return await APIService.GetAsync<ISalesZone, null>(accessToken, SERVICE_PATH, id);
    }

    static async DeleteAsync(accessToken: string, id: number) {
        await APIService.DeleteAsync(accessToken, SERVICE_PATH, id);
    }

    static async CreateOrUpdateAsync(accessToken: string, entry: ISalesZoneCreateOrUpdate): Promise<boolean> {
        return APIService.CreateOrUpdate<ISalesZoneCreateOrUpdate>(accessToken, SERVICE_PATH, entry);
    }

    static async DownloadDetailExcelFileAsync(accessToken: string, fileName: string, latitude: number, longitude: number, distance: number, start: number, count: number, filters?: IFireDepartmentFilters): Promise<void> {
        const extraQuery = `&longitude=${longitude}&latitude=${latitude}&distance=${distance}&start=${start}&count=${count}`;
        return await APIService.DownloadExcelFileAsync(accessToken, SERVICE_PATH, fileName, filters, "downloaddetailexcelfile", extraQuery);
    }

    static async GetInitAsync(accessToken: string): Promise<ISalesZoneInitResult | null> {
        const result: IAPIResult<ISalesZoneInitResult> =
            await fetchGetAsync<IAPIResult<ISalesZoneInitResult>>(
                `/api/${SERVICE_PATH}/init`,
                {},
                accessToken);

        return result.success ? result.data : null;
    }

    static async GetByDistanceComplexAsync(accessToken: string, lattitude: number, longitude: number, distance: number, filters: ISalesZoneFilters, start: number, count: number): Promise<{ total: number, records: ISalesZone[] | null }> {
        var result = await fetchPostAsync<IAPIResult<{ total: number, records: ISalesZone[] | null }>>(
            `/api/${SERVICE_PATH}/getByDistanceComplex?start=${start}&count=${count}&longitude=${longitude}&lattitude=${lattitude}&distance=${distance}`,
            filters,
            accessToken);

        return result.success ? { total: result.data.total, records: result.data.records } : { total: 0, records: null };
    }
}